module.exports = {
    publicPath: '/ecce',
    backendURL: 'http://139.162.159.40:8080'
}


// WEBPACK FOOTER //
// ./vue.config.js